export enum DateType {
  date = 'date',
  month = 'mont',
  hour = 'hour',
  minute = 'minute',
}

export enum DateFormat {
  shortDate = 'shortDate',
  shortTime = 'shortTime',
  fullDate = "yyyy-MM-dd'T'HH:mm:ss.SSS",
  defaultDate = 'dd/MM/yyyy HH:mm'
}

export enum LocalType {
  it = 'it',
  eng = 'en-US'
}